// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"97ebd068","421":"b9d3186e","422":"d9bbae1b","431":"a058c44d","489":"2ceeec7a","507":"3ebb75ea","608":"76ed0ba1","726":"5f01094d","841":"26f45c86","963":"1a537dc5"}[chunkId] + ".chunk.js";
};